import { render } from "./KeyFeatures.vue?vue&type=template&id=72e50466&scoped=true"
import script from "./KeyFeatures.vue?vue&type=script&lang=js"
export * from "./KeyFeatures.vue?vue&type=script&lang=js"

import "./KeyFeatures.vue?vue&type=style&index=0&id=72e50466&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e50466"]])

export default __exports__